import Immutable from 'immutable';
import * as ActionTypes from './ActionTypes';

const initialState = Immutable.Map({
  currentAlert: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SWEETALERT_SET_ALERT:
      return state.set('currentAlert', action.payload);
    case ActionTypes.SWEETALERT_HIDE_ALERT:
      return state.set('currentAlert', null);
    default:
      return state;
  }
};
